export default __webpack_public_path__ + "static/media/corona.226f99c2.png";